import { ChangeDetectionStrategy, Component, Signal, computed, inject } from '@angular/core';
import { FLOATING_PANEL_DATA } from '@shared/floating-panel/floating-panel-data.token';
import { HdNotesPanelComponent } from './hd-notes-panel.component';

/** Paneel-data van de losgemaakte notities: volgt de actieve charttab. */
export interface HdNotesFloatingPanelData {
  readonly savedChartId: string | null;
  readonly chartName: string;
  /** Klik op een linknaam: de pagina opent die chart (in een nieuwe tab). */
  readonly openChart: (chartId: string) => void;
}

/**
 * Het Notities-paneel als zwevend venster (losgemaakt uit de vaste
 * Notities-docktab), zodat je de inhoud van het rechterpaneel (Basis,
 * Geavanceerd, info-panelen) kan lezen en eruit kopiëren terwijl je notities
 * neemt. Dunne wrapper: mapt de paneel-data op de inputs van
 * {@link HdNotesPanelComponent}; de pagina ververst die data bij een
 * tabwissel, zodat het venster altijd de notities van de actieve chart toont.
 */
@Component({
  selector: 'hd-notes-floating-panel',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HdNotesPanelComponent],
  template: `
    @if (data(); as panelData) {
      <hd-notes-panel
        [savedChartId]="panelData.savedChartId"
        [chartName]="panelData.chartName"
        (chartOpenRequested)="panelData.openChart($event)"
      ></hd-notes-panel>
    }
  `,
  styles: `
    :host {
      display: block;
      width: min(460px, 85vw);
      padding: 0 12px 12px;
    }
  `,
})
export class HdNotesFloatingPanelComponent {
  private readonly panelData = inject(FLOATING_PANEL_DATA, { optional: true }) as
    Signal<HdNotesFloatingPanelData | null> | null;

  protected readonly data = computed(() => this.panelData?.() ?? null);
}
